import { Link } from 'react-router-dom';
import { resources } from '@/mocks/resources';
import ResourceCard from '@/components/feature/ResourceCard';

export default function FeaturedSection() {
  const featured = resources.filter((r) => r.featured);

  return (
    <section className="w-full py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-end justify-between mb-10">
          <div>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
              精选资源
            </h2>
            <p className="text-sm md:text-base text-foreground-500">
              编辑团队精心挑选的优质资源，每周更新
            </p>
          </div>
          <Link
            to="/category/study"
            className="hidden sm:flex items-center gap-1 text-sm font-medium text-primary-600 hover:text-primary-700 transition-colors cursor-pointer whitespace-nowrap"
          >
            查看全部 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {featured.slice(0, 6).map((resource) => (
            <ResourceCard key={resource.id} resource={resource} />
          ))}
        </div>

        <div className="mt-10 text-center sm:hidden">
          <Link
            to="/category/study"
            className="inline-flex items-center gap-1 px-6 py-3 bg-primary-500 hover:bg-primary-600 text-background-50 font-bold text-sm rounded-xl transition-all duration-300 cursor-pointer"
          >
            查看全部资源 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}